export default __webpack_public_path__ + "static/media/dsi_logo.56ad8f7b.jpg";